/** import external dependencies */
import 'jquery';
import 'bootstrap';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleWhitePaper from './routes/single-white-paper';

// Slick carousel is likely going to be used across all pages
// on the site - require it here so it's available globally
// on our jQuery object/library as a plugin.
require('slick-carousel');

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,

  singleWhitePaper,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());

// Activate Typekit fonts
try{
  Typekit.load({ async: true });
}catch(e){};



// WEBPACK FOOTER //
// ./scripts/main.js